import type { AppModule } from '@/config/types'

export const serviceToModuleMap = new Map<string, AppModule>()
